import { IS_WHITE_LABEL } from "./brandFlags";
import { isPremiumSubscription, resolveExamSubscription } from "./subscriptionState";

// Resolve the subscription object to gate on for a given exam.
//
// White-label entitlement is PER-EXAM (the old wl-webapp model): the `subscriptions[exam]` map
// (e.g. `subscriptions.cissp`), which lets a partner grant CISSP-only or CISSP+CCSP. There is no
// top-level singular `subscription` for white-label. `resolveExamSubscription` (in @learnzapp/core,
// shared with mobile) normalizes that per-exam record to the gate's shape (millis expiration +
// status, preserving any deny status).
//
// Non-white-label brands use the singular top-level `subscription` (Stripe / RevenueCat) — as-is.
export function activeSubscriptionFor(userDoc, examKey) {
  if (!userDoc) return null;
  if (IS_WHITE_LABEL) {
    return resolveExamSubscription(userDoc, examKey);
  }
  return userDoc.subscription || null;
}

// Does `userDoc` currently hold a premium entitlement for `examKey`? Single web-side
// helper so Router, NotSubscribed, and AuthProvider gate identically — it scopes the
// subscription (per-exam for white-label, singular otherwise) via activeSubscriptionFor,
// then applies the shared core rule (isPremiumSubscription). Mirrors mobile's core
// isExamEntitled.
export function isExamEntitledFor(userDoc, examKey) {
  return isPremiumSubscription(activeSubscriptionFor(userDoc, examKey));
}
